
import { DossierConfigService } from "@/services/dossier-config-service";
import { SellCategory } from "@/utils/sell-category";
import { SellCategoryCalculationParameter } from "@/utils/sell-category-calculation-parameter";
import Vue from "vue";
import AppSellCategoryEditCalculation from "./SellCatergoryEditCalculationParameter.vue";

export default Vue.extend({
	data() {
		return {
			categories: DossierConfigService.getSellCategories(),
		};
	},
	props: {
		category: {
			type: Number,
			required: true
		}
	},
	computed: {
		value():SellCategory {
			let cat = this.categories.getCategories()[this.category - 1];
			if (!cat.Name) {
				cat.Name = "";
			}
			return cat;
		},
		deleteCalculationParameterDisabled():boolean {
			if (!this.value.CalculateViaParameters) {
				return false;
			}
			if (this.value.CalculationParameters.length == 1) {
				return true;
			}
			return false;
		}
	},
	watch: {
		"value.CalculateViaParameters"(val:boolean) {
			if (val && this.value.CalculationParameters.length == 0) {
				this.addParameter();
			}
		}
	},
	methods: {
		async save():Promise<void> {
			if (this.value.CalculateViaParameters) {
				if (this.value.CalculationParameters.length == 0) {
					return this.$wf.notify(this.$ct("error-need-calculation-parameter"), "danger", 3000, "exclamation-triangle");
				}

				if (this.value.LowerHandleValue > this.value.UpperHandleValue) {
					return this.$wf.notify(this.$ct("error-handle-values-incorrect-order"), "danger", 3000, "exclamation-triangle");
				}

				for (let param of this.value.CalculationParameters) {
					if (!param.isValid()) {
						return this.$wf.notify(this.$ct("error-values-incorrect", {val1: param.LowerValue, val2: param.UpperValue}), "danger", 3000, "exclamation-triangle");
					}
				}

				if (!this.value.isValid()) {
					return this.$wf.notify(this.$ct("error-overlapping-values"), "danger", 3000, "exclamation-triangle");
				}
			}


			if (this.value.Name) {
				if (this.value.Name.match(/^\s*$/)) {
					this.value.Name = undefined;
				}
			}

			await DossierConfigService.saveSellCategoryNames(this.categories);
			this.$emit("saved");
			this.$emit("close");
		},
		cancel() {
			this.$emit("close");
		},
		removeParameter(index:number) {
			this.value.CalculationParameters.splice(index, 1);
		},
		addParameter() {
			this.value.CalculationParameters.push(new SellCategoryCalculationParameter());
		}
	},
	components: {
		AppSellCategoryEditCalculation,
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
